import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhQueryAutoWeb, VhImage, VhEventMediator } from 'vhautowebdb';

// import { FunctionService  } from 'vhobjects-service';
// import { FunctionService  } from 'vhobjects-service';
// import { ManageLibraryComponent } from './../../../../manage-library/manage-library.component';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';
import {  ManageLibraryComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
import { AtwUpdateDbComponent } from 'vhobjects-service';

@Component({
  selector: 'atw-messenger-admin-config',
  templateUrl: './messenger-admin-config.component.html',
  styleUrls: ['./messenger-admin-config.component.scss']
})
export class AtwMessengerAdminConfig  extends AtwUpdateDbComponent  {

@Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() device: any; // xác định device là desktop hay mobile
  facebookID: string = '' // Biến lấy giá trị của Facebook ID

  currentViewAll: any = {};
  isCollapsed: boolean = false;
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  public path: any = ''; // đường dẫn lưu ảnh
  configMode: 'basic' | 'advanced' = 'basic';

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    private vhImage: VhImage,
    public functionService: FunctionService,
    private matdialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { 
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }


  /* ------------------------------ UPLOAD IMAGE ------------------------------ */

  /**
   * Hàm sẽ thực hiện disable các option khi lựa chọn tải ảnh nền cho frame
   * @param valueItem
   * @returns
   */
  checkDisableUploadImage(valueItem: any) {
    if (this.config['img']['type'] === valueItem) return false;
    return true;
  }


  openUpload() {
    if (isPlatformBrowser(this.platformId)){
    var inputVal = document.querySelector('#uploadMessenger') as HTMLElement;
    inputVal.click();}
  }


  onUpload(e) {
    const file = e.target.files[0];

    if (file) {
      const image = new Image();

      // Khi image đã được load
      image.onload = () => {
        this.vhImage
          .getThumbnailFromDesktop(
            file,
            image.width,
            image.height,
            'design/object-messenger',
            this.config['img']['src'] || null
          )
          .then(
            (photoURL: any) => {
              this.config['img']['src'] = photoURL;
              this.updateConfig();
              this.functionService.createMessage(
                'success',
                'Hình ảnh đã được tải thành công !!!'
              );
            },
            (error) => {
              console.log(error);
              this.functionService.createMessage(
                'error',
                'Tải ảnh thất bại!'
              );
            }
          );
      };

      // Set src cho img
      const objectURL = URL.createObjectURL(file);
      image.src = objectURL;
    } 
    else {
      this.functionService.createMessage(
        'error',
        'Vui lòng chọn ảnh để tải lên !!!'
      );
    }
  }


  /**
   * Mở thư viện để chọn ảnh
   */
  openLibrary() {
    const dialogRef = this.matdialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path ? this.path : '/images',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(({ name, href, path }) => {
      this.config['img']['src'] = path;
      this.updateConfig();
      this.path = path;
    });
  }


  /* --------------------- Các hàm update --------------------- */

  // /**
  //  * Hàm update class
  //  */
  // updateClass() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {});
  // }

  // /**
  //  * Hàm update config
  //  */
  // updateConfig() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_config']: this.config,
  //     })
  //     .then((bool: any) => {});
  // }

  // /**
  //  * Hàm update object vào database.
  //  */
  // updateObject() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_class']: this.class,
  //       [this.device + '_config']: this.config,
  //       staticdata: this.staticdata,
  //     })
  //     .then((bool: any) => {});
  // }


  /**
   * update trường mobile_portrait_hidden or desktop_hidden cho object
   * @param value
   */
  updateHidden(value) {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, value).then(
      (bool) => {
        
      },
      (error) => {
        console.error(error);
      }
    );
  }

  


  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };


  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
}
